import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RiskConfig } from "../../_interfaces/RiskConfig.model";

@Injectable()
export class RiskCacheService {

  private riskCategoriesCache: {
    value: Observable<RiskConfig>
  }


  public setRiskConfig(value: Observable<RiskConfig>) {
    this.riskCategoriesCache = { value };
  }


  public get riskConfig$(): Observable<RiskConfig> {
    if (!this.riskCategoriesCache) {
      return null;
    }

    return this.riskCategoriesCache.value;
  }
}

